<template>
  <!-- 描述 -->
  <div class="wiki-detail-footer">
    <div class="desc-box">
      <div class="left">
        <!-- 来源 -->
        <span class="source-game" v-if="detail && detail.game">
          来自wiki：<router-link :to="`/${detail.game.alias}/`">
            {{ detail.game.name }}
          </router-link>
        </span>
      </div>
      <div class="right">
        <!-- 历史记录 -->
        <el-popover placement="bottom" trigger="click" width="320" @show="getLogList('init')">
          <div class="log-list">
            <a
              v-for="item in logList"
              :key="item.id"
              :href="getJumpWikiDetailUrl(gameInfo.alias, gameInfo.id, `${item.content_id}_${item.id}`)"
              class="item"
            >
              <img :src="item.user.avatar" alt="" />
              <div class="r-wrapper">
                <div class="user-name">
                  {{ item.user.username }}
                </div>
                <div class="version">
                  {{
                    $t("modified_to_version", {
                      version: item.version
                    })
                  }}
                  {{ item.created_at | dateFormat }}
                </div>
              </div>
            </a>
            <el-pagination
              v-if="logList.length"
              :current-page.sync="logPagination.page_no"
              :page-count="logPagination.page_total"
              background
              class="mT10"
              layout="prev, pager, next"
              @current-change="getLogList"
              hide-on-single-page
            >
            </el-pagination>
            <div v-else style="text-align: center;">无数据</div>
          </div>
          <span slot="reference" class="log-btn">{{ $t("history_record") }}</span>
        </el-popover>

        <!-- 投诉与建议 -->
        <span class="report" style="cursor: pointer;color: #999999" @click="onShowReport">
          <i class="el-icon-warning-outline"></i>
          投诉或建议
        </span>
      </div>
    </div>
    <!-- 举报弹框 -->
    <report-dialog ref="report" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// api
import { apiLogList } from "@/api/contentApi";

// plugins
import { getJumpWikiDetailUrl } from "../../../../plugins/util";
// components
import ReportDialog from "../../components/reportDialog";

export default {
  name: "DetailDesc",
  components: {
    ReportDialog
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      logList: [],
      logPagination: {
        limit: 10,
        page_no: 1,
        page_total: 1,
        total: 0
      },
      bindUrl: "",
      showBindDialog: false
    };
  },
  computed: {
    ...mapGetters(["loginUser", "loginUid", "device", "gameInfo"])
  },
  methods: {
    getJumpWikiDetailUrl,
    // 打开举报弹框
    onShowReport() {
      this.$refs.report.id = this.detail.id;
      this.$refs.report.type = 1;
      this.$refs.report.isShow = true;
    },
    // 校验权限
    hasBtnPermission(value, strict = false) {
      let isShow = false;
      if (this.$hasPermission(value, strict)) isShow = true;
      if (this.detail && this.detail.user.uid == this.loginUid) isShow = true;
      return isShow;
    },

    // 获取历史记录
    getLogList(type) {
      if (type && type == "init" && this.logList.length) return;
      let params = {
        content_id: this.detail.id,
        ...this.logPagination
      };
      apiLogList(params).then(({ data, meta }) => {
        this.logList = data;
        this.logPagination = meta.pagination;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wiki-detail-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  user-select: none;
  margin-bottom: 24px;
  margin-top: 24px;
  .desc-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;

    .left {
      display: flex;
      gap: 8px;
    }
    .source-game {
      a {
        color: #2978f7;
      }
    }
  }

  .right-drop-btn {
    position: relative;
    margin-right: 28px;
    cursor: pointer;
    color: #2978f7;
    font-size: 12px;
  }
}
.log-btn {
  margin-right: 28px;
  color: #2978f7;
  cursor: pointer;
}

.log-list {
  .item {
    display: flex;
    padding: 8px;
    background-color: #f5f5f5;

    & + .item {
      margin-top: 5px;
    }

    img {
      width: 36px;
      height: 36px;
      border-radius: 18px;
      object-fit: cover;
    }

    .r-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 12px;

      .user-name {
        color: #171717;
        font-weight: 400;
        margin-bottom: 2px;
        font-size: 14px;
      }

      .version {
        color: #666666;
        font-size: 12px;
      }
    }
  }
}
</style>
